import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';

import ImageHelpers from './../helpers/image/image-helpers';
import TextHelpers from './text/text-helpers';

import './editor-loader/requests-interceptor';
import './constants';
import './inkive-bundle-replacement';
import './editor-loader/cookies-loader.js';
import './editor-loader/index.js';
import '../../css/editor/index.styl';
import initSentry from './editor-loader/sentry';

initSentry();

// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $);

INKIVE.Text = INKIVE.Text ?? {};
INKIVE.Image = INKIVE.Image ?? {};
INKIVE.Text.Helpers = TextHelpers;
INKIVE.Image.Helpers = ImageHelpers;
